import { useMutation } from "@tanstack/react-query";

import { useStoreAPI } from "shared/services/api";
import { UpdateUserBirthDateRequest } from "shared/services/api/store";

import { useAuthContext } from "~/features/auth";

type Options = {
  onSuccess?: () => void;
};

export const useUpdateBirthDate = ({ onSuccess }: Options = {}) => {
  const { accessToken, refetch } = useAuthContext();
  const api = useStoreAPI({ accessToken });

  const { mutateAsync, isLoading } = useMutation(
    ["users/birthDate"],
    (data: UpdateUserBirthDateRequest) => api.updateUserBirthDate(data),
    {
      onSuccess: () => {
        refetch();
        onSuccess?.();
      },
    }
  );

  return {
    update: mutateAsync,
    isLoading,
  };
};
